<template>
  <div class="Brand">
    <img class="Brand__img" src="https://www.backbord.de/app/themes/backbord/dist/images/svg/logo_1a13ab24.svg" alt="">
  </div>
</template>

<script>
export default {
  name: 'ApplicationBrand'
}
</script>

<style scoped>
.Brand {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #050709;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 8rem;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    left: .875rem;
    line-height: 0;
    position: absolute;
    top: 0;
    -webkit-transition: all .25s ease;
    -o-transition: all .25s ease;
    transition: all .25s ease;
    width: 4.875rem;
    z-index: 5;
}

.Brand__img {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    height: auto;
    margin: 0;
    -webkit-transition: all .25s ease;
    -o-transition: all .25s ease;
    transition: all .25s ease;
    width: 2.125rem;
}
</style>
